export const API_GET_COMPANY = "API_GET_COMPANY"
export const API_GET_COMPANIES = "API_GET_COMPANIES"
export const API_UPDATE_BILLING_PAYMENT_STATUS = "API_UPDATE_BILLING_PAYMENT_STATUS"
export const API_GET_CURRENT_CLIENT_BILL = "API_GET_CURRENT_CLIENT_BILL"
export const RESET_FOCUS_COMPANY = "RESET_FOCUS_COMPANY"
export const API_GET_DHL_PICKUP_HOURS = "API_GET_DHL_PICKUP_HOURS"
